/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShiftAvailableDayOutput } from "../../entities/models/ShiftAvailableDayOutput";
import { modelsShiftAvailableStationOutputSchema } from "./shiftAvailableStationOutputSchema";
import { z } from "zod/v4";

export const modelsShiftAvailableDayOutputSchema = z.object({
    "date": z.optional(z.string()),
get "stations"(){
                return z.array(modelsShiftAvailableStationOutputSchema).optional()
              }
    }) as unknown as z.ZodType<ModelsShiftAvailableDayOutput>